import React, { Component } from "react";
import ButtonIcon from "../../button";
import { NotificationModal } from "../modal/notification-modal.component";
import Icons from "../../icon";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { MODAL_CUSTOM_MESSAGE, UPLOAD_NOTIFICATION_MESSAGE } from "../../../constants/external-constants";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { httpDownload } from "../../../utils/api.utils";

class BtnFileAttachement extends Component {
  constructor(props) {
    super(props);
    this.state = {    
      selectedFileName: "no file selected",
      previewUrl: null,
      originalFileName: null,
      selectedFiles: [],
      showModal: false,
      modalMessage: "",
      showConModal: false,
      isSaving: false,
      selectedIndex: 0,
      isBulkUpload: false,
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    const { files } = this.props;
    if (files && Array.isArray(files)) {
      this.setState({
        selectedFiles: files.map(file => ({
          previewUrl: file.locationUrl,
          originalFileName: file.fileName,
          formattedName: this.formatFileName(file.fileName)
        }))
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.files !== this.props.files) {
        this.setState(prevState => {
            const existingFiles = prevState.selectedFiles || [];
            const newFiles = this.props.files
          ? this.props.files.map(file => ({
                    previewUrl: file.locationUrl || file.previewUrl,
                    originalFileName: file.fileName || file.originalFileName,
                    formattedName: this.formatFileName(file.fileName || file.originalFileName)
            }))
                : [];
        const mergedFiles = [...existingFiles, ...newFiles].filter(
            (file, index, self) =>
                index === self.findIndex(f => f.originalFileName === file.originalFileName)
        );

        return { selectedFiles: mergedFiles };
      });
    }
  }

  handleConfirmationModal = () => {
    this.setState(prevState => ({ showModal: !prevState.showModal }));
  };

  formatFileName = (fileName) => {
    const { maxLength } = this.props;
  
    if (!fileName) return null;
    const extensionIndex = fileName.lastIndexOf(".");
    const hasExtension = extensionIndex !== -1;
    const extension = fileName.substring(extensionIndex);
    const name = fileName.substring(0, extensionIndex);

    if (!maxLength || name.length <= maxLength) return fileName;
  
    if (hasExtension) {      
  
      const displayName = name.substring(0, 12);
      return `${displayName}...${extension}`;
    } else {
      const displayName = fileName.substring(0, 12);
      return `${displayName}...`;
    }
  };
  
  

  handleFileChange = (event) => {
      const { fileSizeMB, fileFormat, totalFiles, fileSizeMBStr } = this.props;
    const maxSize = (fileSizeMB || 1) * 1024 * 1024;
    
    try {
      if (totalFiles) {
        const newFiles = Array.from(event.target.files);
        const isBulk = newFiles.length > 1;
        const validSelectedFiles = this.state.selectedFiles.filter(file => file.originalFileName);
        const currentCount = validSelectedFiles.length;

        this.setState({ isBulkUpload: isBulk });

        if (currentCount + newFiles.length > totalFiles) {
          this.setState({
            modalMessage: `Number of files exceeds the allowable limit of ${totalFiles}`,
            showModal: true
          });
          return;
        }
        
        let totalUploadedSize = validSelectedFiles.reduce((acc, file) => acc + file.size, 0);
        const newFileObjs = [];
          const fileData = [];
        for (let file of newFiles) {
          totalUploadedSize += file.size;
          
          if (totalUploadedSize > maxSize) {
            this.setState({
                modalMessage: `Total file size exceeds the allowable limit of ${fileSizeMBStr} MB`,
              showModal: true
            });
            return;
          }
          
          const extension = file.name.split('.').pop().toUpperCase();
          if (!fileFormat.includes(extension)) {
            this.setState({
              modalMessage: `Only files with the following format are allowed: ${fileFormat.join(", ")}`,
              showModal: true
            });
            return;
          }
  
          const isDuplicate = this.state.selectedFiles.some(
            (existingFile) => existingFile.originalFileName === file.name
          );
  
          if (isDuplicate) {
            this.setState({
              modalMessage: `File with same filename already exists`,
              showModal: true
            });
            return;
              }
              let existingFilesSize = this.state.selectedFiles.reduce((acc, file) => acc + (file.size || 0), 0);
              let newFilesSize = newFiles.reduce((acc, file) => acc + file.size, 0);
              let overAllSize = existingFilesSize + newFilesSize;

              if (overAllSize > maxSize) {
                  this.setState({
                      modalMessage: `Total file size exceeds the allowable limit of ${fileSizeMBStr} MB`,
                      showModal: true
                  });
                  return;
              }
  
          newFileObjs.push({
            previewUrl: URL.createObjectURL(file),
            formattedName: this.formatFileName(file.name),
            originalFileName: file.name,
            size: file.size
          });
          fileData.push(file);
          }
        
        this.setState(
          (prevState) => ({
            selectedFiles: [...prevState.selectedFiles, ...newFileObjs],
            modalMessage: "",
            showModal: false
          }),
          () => {
            if (this.props.onFileSelect) {
              const allPreviewUrls = this.state.selectedFiles.map(
                (fileObj) => fileObj.previewUrl
              );
              this.props.onFileSelect(allPreviewUrls);
            }

            if (this.props.fetchFileData) {
                this.props.fetchFileData(fileData);
          }
          }
        );
      } else {

        const file = event.target.files[0];
        if (!file) {
          this.setState({ 
            selectedFileName: "no file selected", 
            previewUrl: null, 
            originalFileName: null 
          });
          this.handleReset();
          return;
        }
  
        let totalUploadedSize = this.state.selectedFiles.reduce((acc, file) => acc + file.size, 0) + file.size;
        
        if (totalUploadedSize > maxSize) {
          this.setState({
            selectedFileName: "no file selected",
            previewUrl: null,
            originalFileName: null,
              modalMessage: `Total file size exceeds the allowable limit of ${fileSizeMBStr} MB`,
            showModal: true
          });
          this.handleReset();
          return;
        }
        
        const extension = file.name.split('.').pop().toUpperCase();
        if (!fileFormat.includes(extension)) {
          this.setState({
            selectedFileName: "no file selected",
            previewUrl: null,
            originalFileName: null,
            modalMessage: `Only files with the following extensions are allowed: ${fileFormat.join(", ")}`,
            showModal: true
          });
          this.handleReset();
          return;
        }
        
        const isDuplicate = this.state.selectedFiles.some(
          (existingFile) => existingFile.originalFileName === file.name
        );
  
        if (isDuplicate) {
          this.setState({
            modalMessage: `File with name "${file.name}" already exists. Please upload a different file.`,
            showModal: true
          });
          this.handleReset();
          return;
        }
  
        const previewUrl = URL.createObjectURL(file);
        this.setState({
          selectedFileName: this.formatFileName(file.name),
          previewUrl: previewUrl,
          originalFileName: file.name,
          modalMessage: "",
          showModal: false
        });
        if (this.props.onFileSelect) {
          this.props.onFileSelect(previewUrl);
        }
      }
    } finally {
      event.target.value = "";
    }
  };
  
  
  handleUploadClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleReset = () => {
    this.setState({ 
      selectedFileName: "no file selected",
      previewUrl: null,
      originalFileName: null 
    });
    if (this.props.onFileSelect) {
      this.props.onFileSelect("");
    }
  };

  handleRemoveFile = index => {
    this.setState({
      showConModal: true,
      selectedIndex: index
    });
  };

  handleConfModal = async (buttonType) => {
    const { selectedIndex } = this.state;
    if (buttonType === CONFIRMATION_VALUE.Ok) {
      this.setState((prevState) => {
        const updatedFiles = prevState.selectedFiles.filter((_, i) => i !== prevState.selectedIndex);
  
        return {
          selectedFiles: updatedFiles,
          showConModal: false
        };
      }, () => {
          if (this.props.onFileSelect) {
            const allPreviewUrls = this.state.selectedFiles.map(fileObj => fileObj.previewUrl);
            this.props.onFileSelect(allPreviewUrls);
          }
  
        if (this.props.fetchFileData) {
          this.props.fetchFileData([...this.state.selectedFiles],"remove");
        }
      });
    } else {
      this.setState({
        showConModal: false
      });
    }
  };

    downloadFile = async (filepath, fileName) => {
        if (!filepath) {
            alert("No file selected to download.");
            return;
        }

        if (!window.confirm(MODAL_CUSTOM_MESSAGE.export_alert_message)) return;

        try {
            //Local file (not yet saved in azure)
            if (filepath.startsWith("blob:") || filepath.startsWith("data:")) {
                const link = document.createElement("a");
                link.href = filepath;
                link.download = fileName || "download";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return;
            }

            //Already saved in azure - download via API
            await httpDownload('common/fileAttachment/downloadFileViaURL', filepath)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to download file: ${response.statusText}`);
                    }
                    return response.blob();
                })
                .then(blob => {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                    window.URL.revokeObjectURL(downloadUrl);
                });
        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download file.');
        }
    };

  render() {
    const { selectedFileName, selectedFiles, previewUrl, originalFileName } = this.state;
    const { title, totalFiles, isAmending } = this.props;
    const fileSelected = this.state.selectedFiles.filter(file => file.originalFileName)
    return (
      <div className="upload-btn__container">
        <span className="upload-label">{title}</span>
        <div className="upload-btn__items">
         <div className="upload-btn-items__wrapper">
          <input
              type="file"
              ref={this.fileInputRef}
              style={{ display: "none" }}
              multiple={!!totalFiles}
              onChange={this.handleFileChange}
            />
            <ButtonIcon
              onClick={this.handleUploadClick}
              iconLeft="cloud-arrow-up"
              customClassName="header-filter-button"
              labelName="Choose File"
              isDisable={fileSelected.length >= totalFiles}
            />
         </div>
          <div className="upload-info__container">
            {totalFiles ? (
              fileSelected && fileSelected.length > 0 ? (
                selectedFiles.map((fileObj, index) => (
                  fileObj.originalFileName ?
                  (
                  <div key={index} className="tooltip-wrapper">
                    <div className="file-item">
                      
                        <div className="tooltip-text-container">
                            <span className="tool-tip__label">{fileObj.originalFileName}</span>
                        </div>
                      
                        <span 
                          onClick={isAmending 
                            ? () => this.downloadFile(fileObj.previewUrl, fileObj.originalFileName)
                            : () => {}}
                          className="upload-btn__file-label text-black"
                        >
                          {fileObj.formattedName}
                        </span>
                    
                      <Icons
                        name="x-solid"
                        size="9px"
                        customClassName="icon-right"
                        onClick={() => this.handleRemoveFile(index)}
                      />
                    </div>
                  </div>
                  ): null
                ))
              ) : (
                 <span className="upload-btn__file-label">no file selected</span>
              )
            ) : (
              previewUrl ? (
                <span
                  className="upload-btn__file-label text-black"
                  onClick={isAmending 
                    ? () => this.downloadFile(previewUrl, originalFileName)
                    : () => {}}
                >
                  {selectedFileName}
                </span>
              ) : (
                <span className="upload-btn__file-label text-black">{selectedFileName}</span>
              )
            )}
          </div>
        </div>

        <NotificationModal
          show={this.state.showModal}
          title={"Confirmation"}
          customClass={"comment-notification-modal notification-footer"}
          handleModal={this.handleConfirmationModal}
          message={this.state.modalMessage}
        />

        <ConfirmationNotificationModal
          show={this.state.showConModal}
          message={UPLOAD_NOTIFICATION_MESSAGE.RemoveFile}
          title="Confirmation"
          handleModal={this.handleConfModal}
          disabled={this.state.isSaving}
          customClass={'comment-notification-modal modal-text-bold'}
        />
      </div>
    );
  }
}

export default BtnFileAttachement;
